module.exports = __webpack_public_path__ + "img/baoche.5bfa96b8.png";